// extracted by mini-css-extract-plugin
export default {"evaluationModal":"UserSatisfactionSurveyModal_evaluationModal__EbtR9","customTagCheckbox":"UserSatisfactionSurveyModal_customTagCheckbox__SznAc"};